import { Navigate } from 'react-router-dom';

export const OrgSubList = () => <Navigate to="/organization_config" />;

export default OrgSubList;
